import { type FormikProps } from "formik";
import { LockIcon, MailIcon } from "vega-icons";

import { type LoginUserRequest } from "@vega-api/generated/types/loginUserRequest";
import { ThemedButton } from "@vega-core/components/Buttons/ThemedButton";
import { InputControl } from "@vega-core/components/Form/Controls/Input/InputControl";
import { PasswordInput } from "@vega-core/components/Form/Controls/Password/PasswordInput";
import { ValidationErrorText } from "@vega-core/components/Form/Layout/ValidationError";
import { m } from "@vega-core/paraglide/messages";

type DevCredentialsFormProps = {
  formik: FormikProps<LoginUserRequest>;
  loginError: string | undefined;
};

export const DevCredentialsForm = ({
  formik,
  loginError,
}: DevCredentialsFormProps) => (
  <form onSubmit={formik.handleSubmit}>
    <div className="mt-1">
      <InputControl
        background="bg-background/secondary md:bg-background/primary"
        color="text-text/primary"
        error={
          formik.errors.email && formik.touched.email ? formik.errors.email : ""
        }
        icon={<MailIcon className="fill-text/primary" />}
        label={m.formFields_email()}
        name="email"
        onBlur={formik.handleBlur}
        onChange={formik.handleChange}
        placeholder=""
        type="email"
        value={formik.values.email}
        withBorder
      />
    </div>
    <div className="mt-6">
      <PasswordInput
        autocomplete="current-password"
        background="bg-background/secondary md:bg-background/primary"
        error={
          formik.errors.password && formik.touched.password
            ? formik.errors.password
            : ""
        }
        icon={<LockIcon className="w-5 h-auto fill-text/primary" />}
        label={m.formFields_password()}
        name="password"
        onBlur={formik.handleBlur}
        onChange={formik.handleChange}
        value={formik.values.password || ""}
        withBorder
      />
    </div>
    <div className="mt-6">
      {loginError ? (
        <ValidationErrorText dataTestId={loginError}>
          {loginError}
        </ValidationErrorText>
      ) : null}
    </div>
    <div className="mt-10">
      <ThemedButton dataTestId="sign-in-button" fullWidth variant="primary">
        {m.btn_signIn()}
      </ThemedButton>
    </div>
  </form>
);
